<template>
  <div class="org-admin-sum_oas" :class="{ [curTheme]: true }">
    <div class="oas_rows">
      <div class="oas_row oas_row--vivid">
        <div class="oas_cell oas_cell-1">
          <div class="oas_vivid-mask">
            {{ firstTitle }}
          </div>
        </div>
        <div class="oas_cell oas_cell-2">
          {{ data.reduce((sum, cur) => sum + cur.Number, 0) }}
        </div>
      </div>
      <div
        v-for="(o, i) in data"
        :key="`row-${i}`"
        class="oas_row">
        <div class="oas_cell oas_cell-1" v-html="titleRender(o.Title)"/>
        <div class="oas_cell oas_cell-2">{{ o.Number }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    firstTitle: String,
    data: Array,
  },

  methods: {

    titleRender(title) {
      const rules = [
        ['(+)', '<span class="oas_icon-sm oas_icon-sm--plus"></span>'],
        ['(-)', '<span class="oas_icon-sm oas_icon-sm--minus"></span>'],
      ];
      let res = title;
      rules.forEach((rule) => {
        res = res.replace(rule[0], rule[1]);
      });
      return res;
    },

  },

};
</script>

<style lang="scss">
@import "../../styles/common/main";

.org-admin-sum_oas {
  .oas_rows {
    display: table;
    margin-bottom: 40px;
  }
  .oas_icon-sm {
    width: 15px;
    height: 15px;
    display: inline-block;
    @include border-radius(50%);
    text-align: center;
    font-weight: 300;
    margin-left: 5px;
    color: #fff;
    &.oas_icon-sm--plus {
      background: rgba(149, 195, 2, 0.8);
      &:before {
        content: '+';
      }
    }
    &.oas_icon-sm--minus {
      background: rgba(215, 66, 120, 0.8);
      line-height: 16px;
      &:before {
        content: '–';
      }
    }
  }
  .oas_row {
    display: table-row;
    &.oas_row--vivid {
      .oas_cell-1,
      .oas_cell-2 {
        font-size: 18px;
      }
      .oas_cell-1 {
        padding-left: 0;
        font-weight: 400;
        position: relative;
        z-index: 1;
        vertical-align: bottom;
        padding-bottom: 20px;
        .oas_vivid-mask {
          position: relative;
          background: #000;
          z-index: 1;
          display: inline;
          padding-right: 3px;
        }
        &:after {
          content: '';
          position: absolute;
          border-bottom: 4px dotted #fff;
          left: 0;
          right: 0;
          bottom: 23px;
        }
      }
      .oas_cell-2 {
        vertical-align: bottom;
        padding-bottom: 15px;
      }
    }
  }
  .oas_cell {
    display: table-cell;
  }
  .oas_cell-1 {
    font-size: 15px;
    line-height: 18px;
    padding: 0 20px 5px 20px;
    font-weight: 300;
  }
  .oas_cell-2 {
    font-weight: 700;
    padding: 0 0 5px 5px;
    vertical-align: middle;
  }

  &.theme-w {
    .oas_row {
      .oas_cell-1 {
        .oas_vivid-mask {
          background: #fff;
        }
        &:after {
          border-color: #000;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/org-admin/OrgAdminSum.vue